import { NextPage } from 'next';

import SsoSelfJoinRedirect from '../components/_organisms/Auth/SsoSelfJoinRedirect';
import { ssoSelfJoinServerSideProps } from '../utils/ssoSelfJoinSsr';

const ClasslinkLogin: NextPage = () => <SsoSelfJoinRedirect newProvider="classlink" />;

export const getServerSideProps = ssoSelfJoinServerSideProps;

export default ClasslinkLogin;
